import React from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const containerStyles = cva('relative inline-flex', {
  variants: {
    size: {
      small: 'h-[32px] min-h-[32px] w-[32px] min-w-[32px]',
      normal: 'h-[48px] min-h-[48px] w-[48px] min-w-[48px]',
    },
  },
  defaultVariants: {
    size: 'normal',
  },
});

const iconStyles = cva(
  'absolute -bottom-0 -right-0 rounded-full bg-[#565656] p-0.5',
  {
    variants: {
      size: {
        small: 'h-[13.33px] w-[13.33px]',
        normal: 'h-[20px] w-[20px]',
      },
    },
    defaultVariants: {
      size: 'normal',
    },
  }
);

interface AssetIconProps extends VariantProps<typeof containerStyles> {
  assetImg: string;
  networkImg: string;
  assetName?: string;
  networkName?: string;
}

export const AssetIcon: React.FC<AssetIconProps> = (props) => {
  const { assetImg, networkImg, assetName, networkName, size } = props;

  const containerClassNames = twMerge(containerStyles({ size }));
  const iconClassNames = twMerge(iconStyles({ size }));

  return (
    <div className={containerClassNames}>
      <div className='rounded-full bg-[#191A1E] p-2'>
        <img className='h-full w-full' src={assetImg} alt={assetName} />
      </div>
      <div className={iconClassNames}>
        <img className='h-full w-full' alt={networkName} src={networkImg} />
      </div>
    </div>
  );
};
